export function get_rules_from_type(data_type) {
    if (data_type == "int")
        return [
            (v) => !isNaN(v),
            (v) => Number.isInteger(Number(v)),
        ];
    else if (data_type == "number") return [(v) => !isNaN(v)];
    else return []
}